<template>
    <v-list>
        <v-list-item v-for="member in members" :key="member.id">
            <v-list-item-avatar>
                <v-img :src="getMemberImage(member)"></v-img>
            </v-list-item-avatar>

            <v-list-item-content>
                <v-list-item-title v-text="member.name"></v-list-item-title>
            </v-list-item-content>
        </v-list-item>
    </v-list>
</template>

<script>
export default {
    name: 'zoezi-member-list',

    props: {
        members: {}
    },

    methods: {
        getMemberImage(member) {
            return document.location.protocol + '//' + window.location.host + '/api/memberapi/image/member/get?size=50x50&id=' + member.id;
        }
    }
}
</script>